import { styled } from '@mui/material';
import { ReactComponent as GoogleIcon } from '../../../../../assets/images/googleIcon.svg';
import { FormButton } from '../../../../UI';
import { IFormButtonProps } from '../../../../UI/FormButton';

export const Button = styled((props: IFormButtonProps) => (
  <FormButton startIcon={<GoogleIcon style={{ width: 24, height: 24 }} />} variant={'outlined'} {...props} />
))('');
